module App {
    export class SnackbarFactory implements Interfaces.ISnackbarFactory {
        static factoryId = 'snackbarFactory';

        static $inject = [
        ];

        constructor() {

        }
        show = (text: string, duration: number): void => {
            Snackbar.show({ pos: 'top-center', text: text, actionText: 'Oké', showAction: true, actionTextColor: App.Variables.websiteColor, duration: duration });
        }
    }

    app.factory(SnackbarFactory.factoryId, [() => new SnackbarFactory()]);
}